export const groupBy = (arr:Array<any>, key:string) => {
  return arr.reduce(function(prev, curr) {
    (prev[curr[key]] ??= []).push(curr);
    return prev;
  }, {});
};